import { defineStore } from 'pinia'

export const useAtivosStore = defineStore('ativos', {
    state: () => ({
      activeTab: 'equipments',
      filters: {
        equipment: {},
        kit: {},
        model: {},
        auditoria: {}
      }
    }),
    actions: {
      setActiveTab(tab) {
        this.activeTab = tab
      }
    }
  })

export const usePendenciasStore = defineStore('pendencias', {
  state: () => ({
    filtroProblema: '',
    filtroStatus: '',
    filtroUnidade: '',
    filtroSetor: '',
    filtroTipo: '',
    filtroPrioridade: '',
    filtroResponsavelInterno: '',
    filtroResponsavelExterno: '',
    mostrarConcluidos: false,
    mostrarExcluidos: false,
    exibirKanban: false,
  }),
  getters: {
    totalFiltros(state) {
      return [
        state.filtroStatus,
        state.filtroUnidade,
        state.filtroTipo,
        state.filtroPrioridade,
        state.filtroResponsavelExterno,
        state.filtroResponsavelInterno
      ].filter(f => f !== '').length
    }
  },
  actions: {
    limparFiltros() {
      this.filtroProblema = ''
      this.filtroStatus = ''
      this.filtroUnidade = ''
      this.filtroSetor = ''
      this.filtroTipo = ''
      this.filtroPrioridade = ''
      this.filtroResponsavelInterno = ''
      this.filtroResponsavelExterno = ''
    },
    alternarKanban() {
      this.exibirKanban = !this.exibirKanban
    }
  },
  persist: true, // 🔒 Garante que os filtros fiquem salvos mesmo após F5 ou navegação
})
